import { ExpressionType } from '../IExpression.ts';
import { type IAssignableExpression } from '../repository/assignable/IAssignableExpression.ts';

export function isAssignableExpressionNull(expression: IAssignableExpression) {
  if (!expression) return true;
  return (
    expression.type === ExpressionType.Value &&
    (expression.value == null || expression.value === '')
  );
}
